module.exports = __webpack_public_path__ + "static/media/57.009de2d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/57.jpg
// module id = 999
// module chunks = 0